import { combineReducers } from "redux";

// Common
import { Reducers } from "@workspace/common";

// Authentication
import { Reducers as LoginReducers } from "@workspace/login";

// Dashboard
import { Reducers as DashboardReducers } from "@workspace/dashboard";

// Account
import { Reducers as AccountReducers } from "@workspace/account";

// Job
import { Reducers as JobReducers } from "@workspace/job";

// JobPortal
import { Reducers as JobPortalReducers } from "@workspace/jobportal";

// Form
import { Reducers as FormBuilderReducers } from "@workspace/formbuilder";

// Settings
import { Reducers as SettingReducers } from "@workspace/settings";

// Candidate
import { Reducers as CandidateReducers } from "@workspace/candidate";

// Template
import { Reducers as TemplateReducers } from "@workspace/template";

// Report
import { Reducers as ReportReducers } from "@workspace/report";

//Interviw
import { Reducers as InterviewReducers } from "@workspace/interview";

// Portfolio
import { Reducers as PortfolioReducers } from "@workspace/portfolio";

// Assessment
import { Reducers as AssessmentReducers } from "@workspace/assessment";

const {
  Layout,
  CityReducer,
  CountryCurrencyReducer,
  DepartmentReducer,
  IndustryReducer,
  ParentCompanyReducer,
  UserGroupReducer,
  AccountNamesReducer,
  AccountContactReducer,
  FormCommonReducer,
  EmailCommonReducer,
  LinkReducer,
} = Reducers;

const { Login, ForgetPassword, Profile } = LoginReducers;
const { DashboardEcommerce, JobsCount } = DashboardReducers;
const { AccountReducer, AccountRegistrationReducer, AccountFormReducer } =
  AccountReducers;

const { FormReducer } = FormBuilderReducers;

const {
  JobReducer,
  JobFormReducer,
  JobListReducer,
  JobStageReducer,
  TosReducer,
  PreAssessmentReducer,
  PreOfferCandidateReducer,
} = JobReducers;

const { JobPortalJobReducer, JobApplicationReducer } = JobPortalReducers;

const {
  UserReducer,
  RoleReducer,
  ModuleReducer,
  PermissionReducer,
  GroupReducer,
  BenefitsReducer,
} = SettingReducers;

const {
  CandidateFormReducer,
  CandidateReducer,
  CandidateRegistrationReducer,
  CandidateMappingReducer,
} = CandidateReducers;

const { TemplateReducer } = TemplateReducers;

const { ReportReducer } = ReportReducers;

const {
  interviewAnalyticsReducer,
  DailyInterviewsReducer,
  InterviewFormReducer,
} = InterviewReducers;

const { PortfolioReducer, CandidateUserReducer } = PortfolioReducers;

// Assessment
const { AssessmentsReducer, QuestionBankReducer, ResultsReducer } =
  AssessmentReducers;

const rootReducer = combineReducers({
  // Common
  Layout,
  CityReducer,
  CountryCurrencyReducer,
  DepartmentReducer,
  IndustryReducer,
  ParentCompanyReducer,
  UserGroupReducer,
  AccountNamesReducer,
  AccountContactReducer,
  FormCommonReducer,
  EmailCommonReducer,
  LinkReducer,

  // public
  Login,
  ForgetPassword,
  Profile,
  DashboardEcommerce,
  JobsCount,

  // account
  AccountReducer,
  AccountRegistrationReducer,
  AccountFormReducer,

  // Job
  JobReducer,
  JobFormReducer,
  JobListReducer,
  JobStageReducer,
  TosReducer,
  PreAssessmentReducer,
  PreOfferCandidateReducer,

  //JobPortal
  JobPortalJobReducer,
  JobApplicationReducer,

  // Form
  FormReducer,

  // Settings
  UserReducer,
  RoleReducer,
  ModuleReducer,
  PermissionReducer,
  GroupReducer,
  BenefitsReducer,

  //Candidate
  CandidateFormReducer,
  CandidateReducer,
  CandidateRegistrationReducer,
  CandidateMappingReducer,

  // Template
  TemplateReducer,

  // Report
  ReportReducer,

  //Interview
  interviewAnalyticsReducer,
  DailyInterviewsReducer,
  InterviewFormReducer,

  // Portfolio
  PortfolioReducer,
  CandidateUserReducer,

  // Assessment
  AssessmentsReducer,
  QuestionBankReducer,
  ResultsReducer,
});

export default rootReducer;
